// Atlas — collection grid: per-variant card cosmetics + click protection
// 1. Each .atlas-multi-variant li has data-variant-image / data-variant-url / data-variant-color
//    → swap the rendered card's main image to that variant's image, fix the link href
// 2. Disable swatch clicks (just hover effect, click goes to product page)
// 3. Kill multi-image gallery (only show first image)

(function () {
  function atlSwap(el, img) { /* VITESSE 2026-10-13 : même photo -> on ne touche à rien (avant : 2e téléchargement + srcset perdu) ; sinon srcset complet */
    var f = function (u) { return String(u || '').split('?')[0].replace(/^https?:/, ''); };
    if (f(el.getAttribute('src') || el.getAttribute('data-atl-src')) === f(img)) return;
    var b = /[?&]width=\d+/.test(img) ? img.replace(/([?&])width=\d+/, '$1width=') : img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=';
    el.removeAttribute('data-atl-src'); el.removeAttribute('data-atl-srcset');
    el.setAttribute('srcset', [352, 480, 640, 832, 1200].map(function (w) { return b + w + ' ' + w + 'w'; }).join(', '));
    el.src = img;
  }
  function applyVariantToCard(li) {
    const img = li.dataset.variantImage;
    const url = li.dataset.variantUrl;
    const color = li.dataset.variantColor;

    // Swap main image
    if (img) {
      // 13/10/26 : seulement la 1re photo de la carte (la 2e = photo portée, montrée au survol)
      Array.prototype.slice.call(li.querySelectorAll('img.product-media__image, img.product-card__image, product-card img'), 0, 1).forEach(el => {
        atlSwap(el, img);
        if (color) el.setAttribute('alt', color);
      });
    }
    // 28/10/26 (audit cartes) : le « + » ajoute la couleur de la carte (avant : 1re variante en stock du produit, souvent l'argent)
    const vid = li.dataset.variantId;
    const qaInput = li.querySelector('quick-add-component input[name="id"]');
    if (vid && qaInput) qaInput.value = vid;
    // Update product card link href to variant URL
    if (url) {
      li.querySelectorAll('a').forEach(a => {
        try {
          const u = new URL(a.href, location.origin);
          if (u.pathname.includes((window.Shopify.routes.root + 'products/') + li.dataset.productHandle)) a.href = url;
        } catch (e) {}
      });
    }
  }

  function killGallery(li) {
    // Hide all but first product-media__image
    const imgs = li.querySelectorAll('.product-media .product-media__image');
    imgs.forEach((el, i) => { if (i > 1) el.style.display = 'none'; }); // 13/10/26 : on garde la 2e (survol)
    // Disable slideshow
    li.querySelectorAll('slideshow-component, slideshow-arrows').forEach(s => s.removeAttribute('autoplay'));
  }

  function disableSwatchClicks(li) {
    li.querySelectorAll('.variant-option__button-label, .variant-option__swatch, .variant-option--swatches input').forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const link = li.querySelector('a.product-card__link');
        if (link?.href) window.location.href = link.href;
      }, true);
    });
  }

  function init() {
    document.querySelectorAll('li.product-grid__item').forEach(li => {
      killGallery(li);
      disableSwatchClicks(li);
      if (li.classList.contains('atlas-multi-variant')) applyVariantToCard(li);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
